import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { DialogSpeaker, IDialogSpeaker } from 'app/constants/schemas/DialogSpeaker';
import { DialogSentence, IDialogSentence } from 'app/constants/schemas/DialogSentence';

export interface IDialogEntry extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
    stageDirection: boolean | null;
  };
  associations: {
    dialogSpeaker: IDialogSpeaker | null;
    dialogSentence: IDialogSentence[];
  };
}

export type DialogEntry = Entity<IDialogEntry>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DialogEntry: IEntityType<IDialogEntry> = vmClient.defineClass({
  typeName: 'DialogEntry',
  version: 4,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: 'string',
    // True if this entry represents a "stage direction" and does not have a speaker.
    stageDirection: 'boolean',
  },
  associations: {
    dialogSpeaker: {
      type: DialogSpeaker,
      shared: true,
    },
    dialogSentences: {
      type: DialogSentence,
      collection: true,
    },
  },
});
